import { Injectable } from '@angular/core';
import { NotificationService } from '@wms/services';
import { BaseComponent } from '@wms/components';
import { get } from 'lodash-es';
import { getLocalStorageItem, setLocalStorageItem, removeLocalStorageItem } from "../../../../projects/core/src/utils/studio-user-preferences";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CodeInspectService extends BaseComponent {

  ERROR_MESSAGE: string = 'com.wavemaker.no.inspection.results';
  pollStatus: any = {};
  pollInterval: any = {}
  _pit: number = 2000;
  maxCount: number = 6;
  isInspectCodeEnabled: boolean;
  inspectErrorsLoadingFlag: boolean;
  loadLatestErrors: Subject<any> = new Subject<any>();
  jobInterval: any = {};
  download_options: any = {
    name: 'inspection_results.json',
    url: ('/studio/services/projects/${0}/resources/content/web/../project/inspection_results.json').replace('${0}', this.projectService.getProjectId())
  };

  constructor(private notificationService: NotificationService) {
    super();
    this.pollStatus = JSON.parse(getLocalStorageItem('inspectPollStatus_' + this.projectService.getProjectId())) || {
      disableBtn: false,
      prevResultsTimeStamp: Date.now(),
      jobId: 0,
      jobStatus: "",
      refreshedTime: Date.now(),
      showMessage: false
    };

    if(!this.isPollingDone()) {
      //refresh button should be enabled after 30 mins from it's click
      let timeDiff = (30 * 30 * this._pit) - (Date.now() - this.pollStatus.refreshedTime);
      this.jobInterval = setTimeout(() => {
        this.pollStatus.disableBtn = false;
        this.storeJobData();
      }, timeDiff > 0 ? timeDiff  + this._pit  : this._pit);

      this.initPolling(this.pollStatus.jobId, false).then((response) => {
          this.loadLatestErrors.next(response || '');
      }).catch((error) => {});
    }
  }

  initPolling(jobId: any, isFirstTime: any) {
    return new Promise((resolve, reject) => {
      if (!jobId) { return; }
      if (this.pollStatus[jobId] && this.pollStatus[jobId] === this.maxCount) {
        this.inspectErrorsLoadingFlag = false;
        if (!isFirstTime) {
          //this.notificationService.show('info', this.locale['MESSAGE_INFO_TITLE'], this.locale['MESSAGE_INFO_JOB_TOO_LONG']);
          this.pollStatus.showMessage = true;
          //if the issue still persists/takes long time to inspect, just continue with the deployment

          (this.projectService.getInspectErrors() as Promise<any>).then((response: any) => {
            resolve(response);
          }).catch((error: any) => { resolve('') });

          this.pollStatus.refreshedTime = Date.now();
          this.pollStatus[jobId]++;
          this.jobInterval = setTimeout(()=> {
            this.pollStatus.disableBtn = false;
            this.storeJobData();
          }, 30 * 30 * this._pit);
          this.storeJobData();
        }
      }
      (!this.pollStatus[jobId]) ? (this.pollStatus[jobId] = 1) : (this.pollStatus[jobId]++);
      this.pollInterval = setTimeout(() => {
        resolve(this.polling(jobId, isFirstTime));
      }, this.pollStatus[jobId] > this.maxCount ? this._pit * 8 : this._pit);
    });
  }

  endPolling(response: any, jobId: any, isFirstTime: any) {
    return new Promise((resolve, reject) => {
      delete this.pollStatus[jobId];
      clearTimeout(this.pollInterval);
      let status = response !== null ? (response.data ? response.data.state === "complete" : false) : false;
      if (status) {
        resolve(this.load(true, isFirstTime));
      }
      else {
        this.inspectErrorsLoadingFlag = false;
        if (!isFirstTime) {
          let error = response !== null ? (response.data ? response.data.error : "") : "";
          error = this.extractErrorMessage(error);
          this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale['MESSAGE_ERROR_JOB_FAILED'] + "\n" + error);
          this.resetPollStatus();
          resolve(response);
        }
      }
    });
  }

  /**function polls until errors are found in the app
   * @param jobid, jobid for the inspect errors api status**/
  polling(jobId: any, isFirstTime: any) {
    return new Promise((resolve, reject) => {
      (this.projectService.inspectPolling({ jobId: jobId })).then((response: any) => {
        let responseObj = response;
        switch (responseObj.data.state) {
          case 'complete':
          case 'failed': resolve(this.endPolling(responseObj, jobId, isFirstTime)); break;
          default: resolve(this.initPolling(jobId, isFirstTime));
        }
      }).catch((err: any) => {
        resolve(this.endPolling(null, jobId, isFirstTime));
        this.inspectErrorsLoadingFlag = false;
      });
    });
  }

  load(polledstate: any, isFirstTime: any) {
    return new Promise((resolve, reject) => {
      this.inspectErrorsLoadingFlag = true;
      (this.projectService.getInspectErrors() as Promise<any>).then((response: any) => {
        if(response.timestamp && this.pollStatus.jobStatus === "active") {
          if(response.timestamp > this.pollStatus.prevResultsTimeStamp) {
            this.pollStatus.jobStatus = "complete";
            this.storeJobData();
          }
        }
        if(this.pollStatus.jobStatus === "complete") {
          this.loadLatestErrors.next(response);
          if(response?.errors?.length <= 0) {
            this.notificationService.show('success', this.locale['MESSAGE_INFO_TITLE'], this.locale['MESSAGE_SUCCESS_INSPECTION_RESULTS_UPDATED']);
          }
          else {
            this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale['MESSAGE_INSPECTION_ERROR_USING_OVERRIDE_CONFIG'] + response.errors[0]);
          }
          this.resetPollStatus();
        }
        else if(response?.errors?.length > 0) {
          this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale['MESSAGE_INSPECTION_WARN_USING_OVERRIDE_CONFIG'] + response.errors[0]);
        }
        resolve(response);
        this.inspectErrorsLoadingFlag = false;
      }).catch((errorDetails: any) => {
        if (get(errorDetails, 'error.errors.error[0].messageKey') === this.ERROR_MESSAGE && !polledstate) {
          if(this.isPollingDone()) {
            (this.projectService.getInspectJobId() as Promise<any>).then((response: any) => {
              let jobexp = new RegExp('[0-9]*$', 'g'),
                jobid;
              jobid = response.result;
              jobid = jobid.match(jobexp)[0];
              resolve(this.initPolling(jobid, isFirstTime));
              this.pollStatus.jobStatus = "active";
              this.pollStatus.disableBtn = true;
              this.pollStatus.jobId = jobid;
              this.storeJobData();
              this.inspectErrorsLoadingFlag = false;
            }).catch((err: any) => {
              this.inspectErrorsLoadingFlag = false;
              this.resetPollStatus();
              reject();
            });
          }
          else {
            resolve('');
          }
        } else {
          this.inspectErrorsLoadingFlag = false;
          this.resetPollStatus();
          reject();
        }
      });
    })
  }

  /**function to refresh the api and start the poll to get the errors if there are any in the project**/
  refreshInspect() {
    return new Promise(async (resolve, reject) => {
      this.pollStatus.jobStatus = "active";
      this.pollStatus.disableBtn = true;
      try {
        const eslintrcOverrideJS = await this.projectService.getEslintOverrideConfig();
        if(!this.validateJS(eslintrcOverrideJS)) {
          this.resetPollStatus();
          return;
        }
      }
      catch(err) {}
      (this.projectService.getInspectErrors() as Promise<any>).then((response: any) => {
          this.pollStatus.prevResultsTimeStamp = response.timestamp || Date.now();
          this.storeJobData();
      }).catch((errorDetails: any) => {
        this.pollStatus.prevResultsTimeStamp = Date.now();
      });
      //this.inspectErrorsLoadingFlag = true;
      (this.projectService.getInspectJobId() as Promise<any>).then((response) => {
        let jobexp = new RegExp('[0-9]*$', 'g'),
          jobid;
        jobid = response.result;
        jobid = jobid.match(jobexp)[0];
        this.pollStatus.jobId = jobid;
        this.storeJobData();
        resolve(this.initPolling(jobid, false));
      }).catch((error: any) => {
        this.inspectErrorsLoadingFlag = false;
        this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale['MESSAGE_ERROR_JOB_FAILED']);
        this.resetPollStatus();
        reject();
      });
    })
  }

  loadLatestErrorsAsObservable(): Observable<any> {
    return this.loadLatestErrors.asObservable();
  }

  storeJobData() {
    setLocalStorageItem('inspectPollStatus_' + this.projectService.getProjectId(), JSON.stringify(this.pollStatus));
  }

  isPollingDone(): boolean {
    return this.pollStatus.jobStatus === "complete" || this.pollStatus.jobStatus === "";
  }

  resetPollStatus() {
    this.pollStatus = {
      disableBtn: false,
      prevResultsTimeStamp: Date.now(),
      jobId: 0,
      jobStatus: "",
      refreshedTime: Date.now(),
      showMessage: false
    };
    removeLocalStorageItem('inspectPollStatus_' + this.projectService.getProjectId());
  }

  /**
   * Function extracts the error messages lines from the stackStr
   *  @param stackStr represent compelete error object received as string
   */
  extractErrorMessage(stackStr: string): string {
    if (!stackStr) return "";

    const lines = stackStr.split("\n");
    const messageLines: string[] = [];

    for (const line of lines) {
      // stack trace lines always start with "at "
      if (/^\s*at\s.+:\d+:\d+\)?$/.test(line)) {
        break; // stop at the first stack trace line
      }
      if (line.trim()) {
        messageLines.push(line.trim());
      }
    }

    return messageLines.join("\n");
  }

  validateJS(code: string): boolean {
    try {
      new Function(code); // Throws if syntax error
      return true;
    } catch (e) {
      this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], `${this.locale['MESSAGE_INVALID_SCRIPT']} ${(e as any).message}`);
      return false;
    }
  }
}
